export default function fadeIn() {
  document.querySelectorAll(".fade-in").forEach((element) => {
    let observer = new IntersectionObserver((entries) =>
      handler(element, entries)
    );
    observer.observe(element);
  });
}

function handler(element, entries) {
  const delay = element.dataset.delay;
  const duration = element.dataset.duration;
  const slide = element.dataset.slide;

  entries.forEach((entry) => {
    const styles = `
    ${duration ? `transition-duration: ${duration}s` : null};
    ${delay ? `transition-delay: ${delay}s` : null};
    ${slide ? `transform: translateY(-15px)` : null};
    `;

    if (duration) {
      element.setAttribute("style", styles);
    }

    if (slide) {
      element.setAttribute("style", styles);
    }

    if (entry.isIntersecting) {
      setTimeout(function () {
        element.classList.add("fade-in--in-view");
      }, 250);
    }
  });
}
